import React from 'react';
import styled from 'styled-components';
import { hexAnimation } from '../../sharedStyles';


interface BackgroundProps {
  isGrid: boolean,
  backgroundimage: string,
}

interface HexLinkBackgroundProps extends BackgroundProps {
  children: object,
}

const Background = styled.a<BackgroundProps>`
  background-image: ${({ backgroundimage }) => `url(${backgroundimage})`};
  margin: ${({ isGrid }) => (isGrid ? '-66px -23px' : '')};
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  ${hexAnimation}
`;

const HexLinkBackground = ({
  children,
  isGrid,
  backgroundimage,
  ...otherProps
}: HexLinkBackgroundProps) => (
  <Background
    isGrid={isGrid}
    target="_blank"
    rel="noreferrer noopener"
    backgroundimage={backgroundimage}
    {...otherProps}
  >
    {children}
  </Background>
);


export default HexLinkBackground;
